import { motion } from "framer-motion";
import { CalendarCheck, FileText } from "lucide-react";
import { BookingForm } from "./BookingForm";
import { QuoteForm } from "./QuoteForm";
import { Eyebrow, Reveal } from "./Reveal";

const TABS = [
  { id: "book", label: "Book a slot", icon: CalendarCheck },
  { id: "quote", label: "Free quote", icon: FileText },
];

export const Reserve = ({ tab, setTab, services, setServices, promo, setPromo }) => (
  <section id="book" className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-36" data-testid="reserve-section">
    <span id="quote" className="absolute left-0 top-0 h-px w-px" />
    <div className="mb-12 grid gap-6 lg:grid-cols-12 lg:items-end">
      <Reveal className="lg:col-span-7">
        <Eyebrow>Book or quote</Eyebrow>
        <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1] tracking-tight text-white sm:text-5xl lg:text-6xl">
          Your slot is <span className="text-amber-300">waiting.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-5">
        <div className="inline-flex rounded-full border border-white/10 bg-white/5 p-1" role="tablist">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button key={id} role="tab" aria-selected={tab === id} onClick={() => setTab(id)} data-testid={`reserve-tab-${id}`} className="relative flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold">
              {tab === id && <motion.span layoutId="tab-pill" className="absolute inset-0 rounded-full bg-amber-400" transition={{ type: "spring", stiffness: 380, damping: 32 }} />}
              <span className={`relative flex items-center gap-2 transition-colors ${tab === id ? "text-[#0B0F17]" : "text-slate-300"}`}>
                <Icon className="h-4 w-4" /> {label}
              </span>
            </button>
          ))}
        </div>
      </Reveal>
    </div>
    <Reveal>
      <div className="notch-clip rounded-[1.6rem] border border-white/10 bg-[#111827]/80 p-5 shadow-[0_30px_80px_-30px_rgba(245,158,11,0.25)] backdrop-blur-xl sm:p-10">
        {tab === "book" ? <BookingForm services={services} setServices={setServices} promo={promo} setPromo={setPromo} /> : <QuoteForm services={services} setServices={setServices} promo={promo} setPromo={setPromo} />}
      </div>
    </Reveal>
  </section>
);
